export default "__VITE_ASSET__CmwJu71y__"